import Injectable from '@/modules/shared/domain/di/injectable';
import { CreateBeneficiariesRepository } from '../../domain/repositories/create-beneficiaries-repository';

@Injectable()
export default class CreateBeneficiariesDummyRepository implements CreateBeneficiariesRepository {
  create(): Promise<void> {
    return Promise.resolve();
  }
}
